import Microgame from '../engine/Microgame.js';

export default class MergeGame extends Microgame {

    static getPlayback() {
        return {
            title: { fr: `Fusionne !`, en: `Merge!`, es: `¡Fusiona!` },
            controls: { fr: `Fais glisser les pièces identiques l'une sur l'autre`, en: `Drag identical pieces onto each other`, es: `Arrastra piezas idénticas una sobre otra` },
            objective: { fr: `Fusionne tout jusqu'à obtenir l'objet final`, en: `Merge everything until you get the final object`, es: `Fusiona todo hasta obtener el objeto final` },
            icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="var(--secondary-color)" stroke-width="2"><path d="m8 6 4-4 4 4"/><path d="M12 2v10.3a4 4 0 0 1-1.172 2.828L5 21"/><path d="m19 21-5.828-5.828A4 4 0 0 1 12 12.343"/></svg>`,
            actions: [
                { type: 'move', x: 72, y: 54, duration: 220 },
                { type: 'swipe', fromX: 72, fromY: 54, toX: 50, toY: 50, duration: 320 },
                { type: 'wait', duration: 320 },
            ],
            loopDuration: 3000
        };
    }
    constructor(engine) {
        super(engine);
        this.blob1 = null;
        this.blob2 = null;
        this.isDragging = false;
    }

    setup() {
        this.engine.ui.instruction.textContent = "MERGE!";

        // Target Blob (Center)
        this.blob1 = document.createElement('div');
        this.blob1.style.position = 'absolute';
        this.blob1.style.width = '80px';
        this.blob1.style.height = '80px';
        this.blob1.style.border = `4px solid ${this.secondaryColor}`;
        this.blob1.style.borderRadius = '50%';
        this.blob1.style.top = '50%';
        this.blob1.style.left = '50%';
        this.blob1.style.transform = 'translate(-50%, -50%)';
        this.blob1.style.boxShadow = `0 0 10px ${this.secondaryColor}`;
        this.container.appendChild(this.blob1);

        // Drag Blob (Random pos)
        this.blob2 = document.createElement('div');
        this.blob2.style.position = 'absolute';
        this.blob2.style.width = '60px';
        this.blob2.style.height = '60px';
        this.blob2.style.background = this.primaryColor;
        this.blob2.style.borderRadius = '50%';

        // Random start pos (away from center)
        const angle = this.isPlayback ? 0 : Math.random() * Math.PI * 2;
        const dist = this.isPlayback ? 120 : 100 + Math.random() * 50;
        const startX = 50 + Math.cos(angle) * 30; // % approx
        const startY = 50 + Math.sin(angle) * 30; // % approx

        this.blob2.style.left = `${startX}%`;
        this.blob2.style.top = `${startY}%`;
        this.blob2.style.transform = 'translate(-50%, -50%)';
        this.blob2.style.boxShadow = `0 0 10px ${this.primaryColor}`;
        this.container.appendChild(this.blob2);

        // Arrow hint
        const arrow = document.createElement('div');
        arrow.style.position = 'absolute';
        arrow.style.left = '50%';
        arrow.style.top = '50%';
        arrow.style.width = '0';
        arrow.style.height = '0';
        arrow.style.borderLeft = '10px solid transparent';
        arrow.style.borderRight = '10px solid transparent';
        arrow.style.borderBottom = `20px solid ${this.secondaryColor}`;
        arrow.style.transform = `translate(-50%, -50%) rotate(${angle + Math.PI / 2}rad) translateY(60px)`;
        arrow.style.opacity = '0.5';
        this.container.appendChild(arrow);

        this.onDown = this.onDown.bind(this);
        this.onMove = this.onMove.bind(this);
        this.onUp = this.onUp.bind(this);

        this.engine.input.element.addEventListener('pointerdown', this.onDown);
        this.engine.input.element.addEventListener('pointermove', this.onMove);
        this.engine.input.element.addEventListener('pointerup', this.onUp);
    }

    onDown(e) {
        if (!this.active || this.won) return;

        // Check if clicking blob2
        const rect = this.blob2.getBoundingClientRect();
        if (e.clientX >= rect.left && e.clientX <= rect.right &&
            e.clientY >= rect.top && e.clientY <= rect.bottom) {
            this.isDragging = true;
        }
    }

    onMove(e) {
        if (!this.active || !this.isDragging) return;

        const rect = this.container.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;

        this.blob2.style.left = `${x}px`;
        this.blob2.style.top = `${y}px`;

        // Check overlap
        const r1 = this.blob1.getBoundingClientRect();
        const r2 = this.blob2.getBoundingClientRect();

        const dist = Math.sqrt(
            Math.pow((r1.left + r1.width / 2) - (r2.left + r2.width / 2), 2) +
            Math.pow((r1.top + r1.height / 2) - (r2.top + r2.height / 2), 2)
        );

        if (dist < 20) {
            this.win();
            this.blob2.style.display = 'none';
            this.blob1.style.background = this.primaryColor;
            this.blob1.style.transform = 'translate(-50%, -50%) scale(1.5)';
            this.blob1.style.transition = 'transform 0.2s';
        }
    }

    onUp() {
        this.isDragging = false;
    }

    cleanup() {
        super.cleanup();
        this.engine.input.element.removeEventListener('pointerdown', this.onDown);
        this.engine.input.element.removeEventListener('pointermove', this.onMove);
        this.engine.input.element.removeEventListener('pointerup', this.onUp);
    }
}
